import React from 'react';
import ReactDOM from 'react-dom/client'; // Importar de 'react-dom/client'
import 'normalize.css'; // Importação do normalize.css
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    
      <App />
    
  </React.StrictMode>
);